const items = document.querySelectorAll(".accordion details");
items.forEach((details) => {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".accordion__content");
    summary.addEventListener("click", (e) => {
        e.preventDefault();
        const isOpen = details.open;
        items.forEach((item) => {
            if (item !== details && item.open) {
                close(item);
            }
        });
        if (isOpen) {
            close(details);
        } else {
            open(details);
        }
    });

    function open(details) {
        const content = details.querySelector(".accordion__content");
        details.open = true;
        const height = content.scrollHeight;
        content.style.height = "0px";
        requestAnimationFrame(() => {
            content.style.height = height + "px";
        });
        content.addEventListener("transitionend", () => {
            content.style.height = "auto";
        }, {
            once: true
        });
    }

    function close(details) {
        const content = details.querySelector(".accordion__content");
        const height = content.scrollHeight;
        content.style.height = height + "px";
        requestAnimationFrame(() => {
            content.style.height = "0px";
        });
        content.addEventListener("transitionend", () => {
            details.open = false;
        }, {
            once: true
        });
    }
});


document.addEventListener("click", (event) => {
    const label = event.target.closest("variant-selects label");
    if (!label) return;

    setTimeout(backInStockInitial, 2000);
});
function backInStockInitial() {
    const backInStockButtonContainer = document.querySelector('[data-essential-preorder-element="back-in-stock-container"]');
    const backInStockButton = backInStockButtonContainer?.querySelector('[data-essential-preorder-element="back-in-stock-container"] button');

    if (!backInStockButton) return;

    backInStockButtonContainer.style.display = 'block'; 

    backInStockButton.addEventListener('click', backInStock);

    const initial = document.querySelector('.quantity_buy-buttons');

    if (initial.classList.contains('initialize')) {
        initial.classList.remove('initialize');
    }
}

function backInStock() {
    let varImageContainer = document.querySelectorAll('.product__media-list li')[0];
    let varImage = varImageContainer.querySelector('.product__media').cloneNode(true);
    const bisWrapper = document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-wrapper"]');
    const bisDescription = document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-description"]');
    const popupForm = document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-container"] form');
    const emailInput = document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-input"]');
    const bisLabel = document.createElement('span');
    const successMessage = document.createElement('p');

    const newForm = document.createElement('form');
    const isMarketing = document.createElement('input');
    const isMarketingLabel = document.createElement('label');
    const isMarketingCheckBox = document.createElement('span');


    newForm.setAttribute('method', 'POST');
    newForm.setAttribute('action', '/contact');
    newForm.setAttribute('id', 'newsletterForm');
    
    popupForm.after(newForm); 

    isMarketing.type = 'checkbox';
    isMarketing.name = 'contact[tags]';
    isMarketing.value = 'consented';
    isMarketing.id = 'isMarketing';
    
    isMarketingLabel.innerHTML = '<span class="checkLabel">Subscribe to Little Lullaby newsletter</span>';
    isMarketingLabel.setAttribute('for','isMarketing');
    isMarketingLabel.setAttribute('id','isMarketingLabel');
    
    isMarketingCheckBox.classList.add('isMarketingCheckBox');

    newForm.prepend(isMarketing);

    isMarketingLabel.prepend(isMarketingCheckBox);


    bisLabel.classList.add('bisLabel');
    bisLabel.textContent = 'Sign up to be the first to know when this item is back in stock:';

    successMessage.classList.add('success-messsage');
    successMessage.textContent = 'We’ll notify you once the product becomes available.';


    bisWrapper.prepend(varImage);
    bisDescription.innerHTML = bisDescription.textContent + ' <span>sold out</span>!';

    bisDescription.after(bisLabel); 
    bisDescription.after(successMessage); 

    emailInput.after(isMarketingLabel);

    isMarketing.addEventListener('change', function() {
        if( this.checked ) {
            toggleMarketing();
        } else {
            removeMarketingForm();
        }
        isMarketingLabel.classList.toggle('checked');
    });

    newForm.addEventListener("submit", function(e) {
        e.preventDefault();

        setTimeout(() => {
            location.reload();
        }, 1000);
    });

}

function toggleMarketing() {
    const submitButton = document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-button"]');
    const emailInput = document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-input"]');
    const newForm = document.getElementById('newsletterForm');
    const isMarketing = document.getElementById('isMarketing');

    const emailInputValue = emailInput?.value ?? "";

    const formDiv = document.createElement('div');

    const customerType = document.createElement('input');
    const utf8 = document.createElement('input');
    const newsLetter = document.createElement('input');
    const newEmail = document.createElement('input');

    formDiv.setAttribute('id', 'formDiv');

    customerType.type = 'hidden';
    customerType.name = 'form_type';
    customerType.value = 'customer';

    utf8.type = 'hidden';
    utf8.name = 'utf8';
    utf8.value = '✓';

    newsLetter.type = 'hidden';
    newsLetter.name = 'contact[tags]';
    newsLetter.value = 'newsletter';

    newEmail.type = 'hidden';
    newEmail.name = 'contact[email]';
    newEmail.value = emailInputValue;


    isMarketing.after(formDiv);

    formDiv.prepend(newEmail);
    formDiv.prepend(newsLetter);
    formDiv.prepend(utf8);
    formDiv.prepend(customerType);

    submitButton.addEventListener('click', submitForm);

    emailInput.addEventListener('input', function() {
        newEmail.value = emailInput.value;
    });

}

function submitForm() {
    const newForm = document.getElementById('newsletterForm');
    newForm.submit();
}

function removeMarketingForm() {
    const submitButton = document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-button"]');
    const newForm = document.querySelector('#formDiv');

    newForm.remove();
    submitButton.removeEventListener('click', submitForm);
}
window.addEventListener("load", backInStockInitial, { once: true });
window.addEventListener("focus", backInStockInitial, { once: true });


const varInput = document.querySelector('.product-variant-id');
document.addEventListener('click', (event) => {
    setTimeout(togSubmit, 2000);
});

function togSubmit() {
    const subB = document.querySelector('.product-form .product-form__buttons > button.product-form__submit');
    const fSubB = document.querySelector('.floating_atc button.product-form__submit');
    if (subB.disabled) {
        fSubB.disabled = true;
    } else {
        fSubB.disabled = false;
    }
}